/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import { productListFilterAccordionSectionStyles } from "@insite/content-library/Widgets/ProductList/ProductListFilterAccordionSection";
import getColor from "@insite/mobius/utilities/getColor";
import CaretDown from "@monsma/XDL/Icons/CaretDown";
import { styledScrollbar } from "@monsma/XDL/Utilities/sharedStyles";
import { css } from "styled-components";

productListFilterAccordionSectionStyles.accordionSection = {
    panelProps: {
        css: css`
            overflow-y: auto;
            overflow-x: hidden;
            max-height: 190px;
            border: 0;
            padding: 8px 15px 0 0;
            margin-top: 15px;
            ${styledScrollbar};
        `,
    },
    headerProps: {
        css: css`
            button {
                border: 0;
                background: ${getColor("common.background")};
                padding: 15px 0 0;

                &:focus {
                    border: 0;
                    padding: 15px 0 0;
                }
            }
        `,
    },
    titleTypographyProps: {
        lineHeight: "20px",
        size: "14px",
    },
    toggleIconProps: {
        src: CaretDown,
        size: 13,
        color: "common.ui10",
    },
};

productListFilterAccordionSectionStyles.checkBoxGroup = {
    css: css`
        margin-bottom: 14px;
    `,
};

productListFilterAccordionSectionStyles.checkBox = {};

productListFilterAccordionSectionStyles.checkBoxSelected = {};

productListFilterAccordionSectionStyles.seeAllLink = {
    css: css`
        padding-top: 0;
    `,
};

productListFilterAccordionSectionStyles.seeLessLink = {
    css: css`
        padding-top: 0;
    `,
};
